import { IconExternalLink } from '@/shared/ui/icons';

import type { DropdownMenuItem } from './types';

/**
 * Пункт меню, открывающий адрес в новой вкладке. Адрес не собрать (нет origin'ов
 * сборки) — пункта нет.
 */
export function externalLinkMenuItems(id: string, label: string, resolveHref: () => string): DropdownMenuItem[] {
  try {
    const href = resolveHref();

    return [
      {
        id,
        label,
        icon: IconExternalLink,
        onClick: () => {
          window.open(href, '_blank', 'noopener');
        },
      },
    ];
  } catch {
    return [];
  }
}
